const BANNER_KEY = 'prime_banner_last_closed';

export const isBannerClosedToday = (): boolean => {
  if (typeof window === 'undefined') return false;
  const lastClosed = localStorage.getItem(BANNER_KEY);
  const today = new Date().toLocaleDateString('en-CA');
  return lastClosed === today;
};

export const closeBannerForToday = (): void => {
  if (typeof window === 'undefined') return;
  const today = new Date().toLocaleDateString('en-CA');
  localStorage.setItem(BANNER_KEY, today);
};
